import React, { createContext, useContext, useEffect, useState, useMemo } from "react";
import { getContent } from "../lib/api";
import {
  SERVICES as MOCK_SERVICES,
  PROJECTS as MOCK_PROJECTS,
  PROJECT_CATEGORIES as MOCK_CATEGORIES,
  PRICING as MOCK_PRICING,
  TEAM as MOCK_TEAM,
  TESTIMONIALS as MOCK_TESTIMONIALS,
  FAQS as MOCK_FAQS,
  BLOG as MOCK_BLOG,
  CONTACT as MOCK_CONTACT,
} from "../mock/mock";

const ContentContext = createContext(null);

// Fallback keeps UI alive if the API is unreachable.
const FALLBACK = {
  services: MOCK_SERVICES.map((s) => ({ icon: s.title, title: s.title, desc: s.desc })),
  projects: MOCK_PROJECTS,
  categories: MOCK_CATEGORIES,
  pricing: MOCK_PRICING,
  team: MOCK_TEAM,
  testimonials: MOCK_TESTIMONIALS,
  faqs: MOCK_FAQS,
  blog: MOCK_BLOG,
  contact: MOCK_CONTACT,
};

export function ContentProvider({ children }) {
  const [content, setContent] = useState(FALLBACK);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    getContent()
      .then((data) => active && setContent({ ...FALLBACK, ...data }))
      .catch(() => active && setContent(FALLBACK))
      .finally(() => active && setLoading(false));
    return () => { active = false; };
  }, []);

  const value = useMemo(() => ({ content, loading }), [content, loading]);

  return (
    <ContentContext.Provider value={value}>
      {children}
    </ContentContext.Provider>
  );
}

export const useContent = () => {
  const ctx = useContext(ContentContext);
  return ctx || { content: FALLBACK, loading: false };
};

// Returns contact details merged with the mock defaults (so socials etc. always exist)
export const useContact = () => {
  const { content } = useContent();
  return { ...MOCK_CONTACT, ...(content?.contact || {}) };
};
